import React, { useState, useEffect } from "react";
import ImageViewer from "../../screens/ImageViewerV2.js";
import {
  getAllPublicDataV2,
  getScenesInPrototypeForPublic,
} from "../../api/configuratorApiV2.js";
import styles from "./ConfiguratorViewer.module.scss";
import { useParams } from "react-router-dom";
// import { history } from "../../history";
// import {
//   configuratorData1,
//   layoutData1,
//   profileData1,
//   sceneData1,
//   imageData1,
// } from "../../helpers/configuratorInfo1";
import {
  configuratorData13,
  layoutData13,
  profileData13,
  sceneData13,
  imageData13,
} from "../../helpers/configuratorInfo13";
import { AnimatedLoader } from "../Loader/AnimatedLoader.js";
import { configuratorData29,
  layoutData29,
  profileData29,
  sceneData29,
  imageData29, } from "../../helpers/configuratorInfo29";
import { configuratorData21, imageData21, layoutData21, profileData21, sceneData21 } from "../../helpers/configuratorInfo21.js";
import { configuratorData5, imageData5, layoutData5, profileData5, sceneData5 } from "../../helpers/configuratorInfo5.js";
import { configuratorData9, imageData9, layoutData9, profileData9, sceneData9 } from "../../helpers/configuratorInfo9.js";
import { configuratorData53, imageData53, layoutData53, profileData53, sceneData53 } from "../../helpers/configuratorInfo53.js";
import { configuratorData12, imageData12, layoutData12, profileData12, sceneData12 } from "../../helpers/configuratorInfo12.js";
import { configuratorData10, imageData10, layoutData10, profileData10, sceneData10 } from "../../helpers/configuratorInfo10.js";
import { configuratorData8, imageData8, layoutData8, profileData8, sceneData8 } from "../../helpers/configuratorInfo8.js";
import { configuratorData24, imageData24, layoutData24, profileData24, sceneData24 } from "../../helpers/configuratorInfo24.js";
import Loader from "../../common/Loader.js";

let isMounted = false;

const ConfiguratorViewer = () => {
  const { uuid } = useParams();
  const [loader, setLoader] = useState(false);
  const [allStoreList, setAllStoreList] = useState([]);
  const [currentSelectedStore, setCurrentSelectedStore] = useState({});
  const [token, setToken] = useState(null);
  const [isRender, setIsRender] = useState(false);
  const [localConfiguratorData, setLocalConfiguratorData] = useState();
  const [localLayoutData, setLocalLayoutData] = useState();
  const [localProfileData, setLocalProfileData] = useState();
  const [localSceneData, setLocalSceneData] = useState();
  const [localImageData, setLocalImageData] = useState();
  const [allScenes, setAllScenes] = useState([]);
  const [measureToolImages, setMeasureToolImages] = useState([]);

  // if (!uuid) {
  //   history.push("/configurator/1");
  // }

  useEffect(() => {
    isMounted = true;
  }, []);

  useEffect(() => {
    if (localConfiguratorData?.tokenUrl) {
      setIsRender(checkIfShowRenderData());
      getAllDataFromModelId(checkIfShowRenderData());
    }
  }, [localConfiguratorData]);

  useEffect(() => {
    if (uuid) {
      updateDataForModelIdLocal(uuid);
    }
  }, [uuid]);

  // useEffect(() => {
  //   getDataFromJSON()
  // }, [])

  // const getDataFromJSON = async (obj) => {
  //   await fetch('/measureToolImages.json')
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error('Network response was not ok');
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       const allImages = data.allImages;
  //       if (allImages.length) {
  //         const id = parseInt(!isNaN(parseInt(uuid)) ? parseInt(uuid): 1);
  //         let index = 0;
  //         if (allImages?.[id-1]) {
  //           index = id - 1;
  //         }
  //         let currentConfImages = allImages?.[index]?.imagesList;
  //         if (currentConfImages?.length) {
  //           if (obj?.showSize) {
  //             currentConfImages = currentConfImages.filter((data) => data?.size === obj?.selectSize);
  //           }
  //           setMeasureToolImages(currentConfImages);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Fetch error:', error);
  //     });
  //   }

  const updateDataForModelIdLocal = (uuid) => {
    switch (uuid) {
      case "13": {
        setLocalConfiguratorData(configuratorData13);
        setLocalLayoutData(layoutData13);
        setLocalImageData(imageData13);
        setLocalProfileData(profileData13);
        setLocalSceneData(sceneData13);
        break;
      }
      case "29": {
        setLocalConfiguratorData(configuratorData29);
        setLocalLayoutData(layoutData29);
        setLocalImageData(imageData29);
        setLocalProfileData(profileData29);
        setLocalSceneData(sceneData29);
        break;
      }
      case "21": {
        setLocalConfiguratorData(configuratorData21);
        setLocalLayoutData(layoutData21);
        setLocalImageData(imageData21);
        setLocalProfileData(profileData21);
        setLocalSceneData(sceneData21);
        break;
      }
      case "5": {
        setLocalConfiguratorData(configuratorData5);
        setLocalLayoutData(layoutData5);
        setLocalImageData(imageData5);
        setLocalProfileData(profileData5);
        setLocalSceneData(sceneData5);
        break;
      }
      case "53": {
        setLocalConfiguratorData(configuratorData53);
        setLocalLayoutData(layoutData53);
        setLocalImageData(imageData53);
        setLocalProfileData(profileData53);
        setLocalSceneData(sceneData53);
        break;
      }
      case "9": {
        setLocalConfiguratorData(configuratorData9);
        setLocalLayoutData(layoutData9);
        setLocalImageData(imageData9);
        setLocalProfileData(profileData9);
        setLocalSceneData(sceneData9);
        break;
      }
      case "12": {
        setLocalConfiguratorData(configuratorData12);
        setLocalLayoutData(layoutData12);
        setLocalImageData(imageData12);
        setLocalProfileData(profileData12);
        setLocalSceneData(sceneData12);
        break;
      }
      case "10": {
        setLocalConfiguratorData(configuratorData10);
        setLocalLayoutData(layoutData10);
        setLocalImageData(imageData10);
        setLocalProfileData(profileData10);
        setLocalSceneData(sceneData10);
        break;
      }
      case "8": {
        setLocalConfiguratorData(configuratorData8);
        setLocalLayoutData(layoutData8);
        setLocalImageData(imageData8);
        setLocalProfileData(profileData8);
        setLocalSceneData(sceneData8);
        break;
      }
      case "24": {
        setLocalConfiguratorData(configuratorData24);
        setLocalLayoutData(layoutData24);
        setLocalImageData(imageData24);
        setLocalProfileData(profileData24);
        setLocalSceneData(sceneData24);
        break;
      }
      default: {
        setLocalConfiguratorData(configuratorData13);
        setLocalLayoutData(layoutData13);
        setLocalImageData(imageData13);
        setLocalProfileData(profileData13);
        setLocalSceneData(sceneData13);
      }
    }
  };

  const checkIfShowRenderData = () => {
    return true;
  };

  const getAllDataFromModelId = async (isRender) => {
    try {
      setLoader(true);
      const promise = getAllPublicDataV2({
        newModelIds: localConfiguratorData?.tokenUrl,
        isRender,
        isOpenedFromAdminPanel: false,
      });
      const promise1 = getScenesInPrototypeForPublic({
        token: localConfiguratorData?.tokenUrl,
        is_render: isRender,
      });
      const promises = [promise, promise1];
      const data = await Promise.all(promises);
      const allData = data?.[0] || {};
      setAllScenes(data[1]);
      const rawData = JSON.parse(JSON.stringify(allData));
      if (allData?.results?.length) {
        setAllStoreList(allData?.results);
        setToken(
          rawData?.results?.[0]?.token || localConfiguratorData?.tokenUrl
        );
        setCurrentSelectedStore(allData?.results[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="h-100 w-100">
      <div
        className={`${styles.topDiv} ${false ? styles.calcHeight : "h-100"}`}
      >
        <div className="w-100 h-100">
          {!loader && (
            <ImageViewer
              scenes={allScenes}
              isImageViewer={false}
              selectedStoreLocal={currentSelectedStore}
              allStoreList={allStoreList}
              modelId={token}
              isRender={isRender}
              localLayoutData={localLayoutData}
              localImageData={localImageData}
              localProfileData={localProfileData}
              localSceneData={localSceneData}
              measureToolImages={measureToolImages}
            />
          )}
        </div>
      </div>
      {loader && (
        <AnimatedLoader
          hideLoadingText={true}
          zIndex={1000}
          position="fixed"
          top={0}
          backDrop={"rgba(255, 255, 255, 1"}
        />
      )}
    </div>
  );
};

export default ConfiguratorViewer;
